export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10425.c2769aae.jpg";